import { Body, Controller, Delete, Get, Param, Post, Put, Req, UsePipes, ValidationPipe } from '@nestjs/common';
import { ApiCreatedResponse, ApiForbiddenResponse, ApiOkResponse, ApiTags } from '@nestjs/swagger';
import { EmployeeDetailsService } from './employee-details.service';
import { EmployeeDetailsDTO } from './dto/employee-details.dto';
import { InformationMessageError, NoRecordsFound, InternalServerError, ValidationMessageError, errorHandler, ApplicationExceptionHandler } from '@gtpl/shared-utils/error-messages';
import { ActiveEmployeesRequest } from './dto/active-employees.request';
// import { EmployeesResponseModel } from './dto/employees-response.model';
import { EmployeeEmpCodeRequest, EmployeeIdRequest, EmployeeTerminateRequest } from './dto/employee.request';
import { EmployeeDetails } from './employee-details.entity';
import { ErrorResponse } from '@gtpl/shared-models/common-models';
import { EmployeeResponseModel, AllEmployeesResponseModel, EmployeesStatusWiseResponseModel, EmployeesDeptWiseResponseModel } from '@gtpl/shared-models/gtpl';
import { CommonResponse } from '@gtpl/shared-models/masters';


@ApiTags('EmployeeDetails')
@Controller('employee-details')
export class EmployeeDetailsController {
  constructor(
    private employeeDetailsService: EmployeeDetailsService,
    private readonly applicationExceptionHandler: ApplicationExceptionHandler
  ) { }
  @Post('/createEmployee')
  @UsePipes(new ValidationPipe())
  async createEmployee(@Body() employeeDetailsDTO: EmployeeDetailsDTO, isUpdate: boolean = false, @Req() request: Request): Promise<EmployeeResponseModel> {
    try {
      return await this.employeeDetailsService.createEmployee(employeeDetailsDTO, false, request);
    } catch (error) {
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
      // return errorHandler(EmployeeResponseModel, error);
    }
  }
  @Post('/getAllEmployees')
  async getAllEmployees(@Req() request: Request): Promise<AllEmployeesResponseModel> {
    try {
      const userid = request.headers['userid'];
      const role = request.headers['role'];
      return await this.employeeDetailsService.getAllEmployees(userid, role);
    } catch (error) {
      // return errorHandler(AllEmployeesResponseModel, error);
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error);
    }
  }

  // @Post('/getTerminatedEmployees')
  // async getTerminatedEmployees(): Promise<AllEmployeesResponseModel> {
  //     try {
  //     return await this.employeeDetailsService.getTerminatedEmployees();
  //     } catch (error) {
  //     return errorHandler(AllEmployeesResponseModel, error);
  //     }
  // }
  @Post('/getActiveEmployees')
  async getActiveEmployees(): Promise<AllEmployeesResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmployees();
    } catch (error) {
      // return errorHandler(AllEmployeesResponseModel, error);
      return this.applicationExceptionHandler.returnException(AllEmployeesResponseModel, error);
    }
  }

  @Post('/getActiveEmpDeptWiseCount')
  async getActiveEmpDeptWiseCount(@Body() deptId: number): Promise<EmployeesDeptWiseResponseModel> {
    try {
      return await this.employeeDetailsService.getActiveEmpDeptWiseCount(deptId);
    } catch (error) {
      // return errorHandler(AllEmployeesResponseModel, error);
      return this.applicationExceptionHandler.returnException(EmployeesDeptWiseResponseModel, error);
    }
  }
  // @Post('/getActiveEmpCount')
  // async getActiveEmpCount(): Promise<EmployeesStatusWiseResponseModel> {
  //   try {
  //     return await this.employeeDetailsService.getActiveEmpCount();
  //   } catch (error) {
  //     return errorHandler(EmployeesStatusWiseResponseModel, error);
  //   }
  // }
  // @Post('/getTerminationCount')
  // async getTerminationCount(): Promise<EmployeesStatusWiseResponseModel> {
  //   try {
  //     return await this.employeeDetailsService.getTerminationCount();
  //   } catch (error) {
  //     return errorHandler(EmployeesStatusWiseResponseModel, error);
  //   }
  // }
  // @Post('/getTerminationApprovalCount')
  // async getTerminationApprovalCount(): Promise<EmployeesStatusWiseResponseModel> {
  //   try {
  //     return await this.employeeDetailsService.getTerminationApprovalCount();
  //   } catch (error) {
  //     return errorHandler(EmployeesStatusWiseResponseModel, error);
  //   }
  // }
  @Post('/updateEmployee')
  async updateEmployee(@Body() employeeDetailsDTO: EmployeeDetailsDTO, @Req() request: Request): Promise<EmployeeResponseModel> {
    console.log(employeeDetailsDTO);
    try {
      return await this.employeeDetailsService.createEmployee(employeeDetailsDTO, true, request);
    } catch (error) {
      // return errorHandler(EmployeeResponseModel, error);
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }
  //   @Post('/getEmployeeById')
  // async getEmployeeById(@Body() employeeIdRequest: EmployeeIdRequest): Promise<EmployeeResponseModel> {
  //   try {
  //     return await this.employeeDetailsService.getEmployeeById(employeeIdRequest.employeeId);
  //   } catch (error) {
  //     return errorHandler(EmployeeResponseModel, error);
  //   }
  // }
  // @Post('/getEmployeeByEmpCode')
  // async getEmployeeByEmpCode(@Body() employeeEmpCodeRequest: EmployeeEmpCodeRequest): Promise<EmployeeResponseModel> {
  //   try {
  //     return await this.employeeDetailsService.getEmployeeByEmpCode(employeeEmpCodeRequest.empCode);
  //   } catch (error) {
  //     return errorHandler(EmployeeResponseModel, error);
  //   }
  // }
  // @Post('/terminateEmployee')
  // async terminateEmployee(@Body() employeeDetailsDTO: EmployeeDetailsDTO,@Req() request:Request): Promise<EmployeeResponseModel> {
  //     try {
  //     return await this.employeeDetailsService.terminateEmployee(employeeDetailsDTO,request);
  //     } catch (error) {
  //     return errorHandler(EmployeeResponseModel, error);

  //     }
  // }
  // @Post('/approveEmployeeTermination')
  // async approveEmployeeTermination(@Body() employeeDetailsDTO: EmployeeDetailsDTO,@Req() request:Request): Promise<EmployeeResponseModel> {
  //     try {
  //     return await this.employeeDetailsService.approveEmployeeTermination(employeeDetailsDTO,request);
  //     } catch (error) {
  //     return errorHandler(EmployeeResponseModel, error);
  //     }
  //   }
  @Post('/updateEmployeeStatus')
  async updateEmployeeStatus(@Body() employeeDto: EmployeeDetailsDTO, @Req() request: Request): Promise<EmployeeResponseModel> {
    try {
      return await this.employeeDetailsService.createEmployee(employeeDto, true, request);
    } catch (error) {
      // return errorHandler(EmployeeResponseModel, error);
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }

  @Post('/updateDesignationForDesignationAction')
  async updateDesignationForDesignationAction(@Body() employeeId: number, designation: string): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.updateDesignationForDesignationAction(employeeId, designation);
    } catch (error) {
      // return errorHandler(EmployeeResponseModel, error);
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }
  @Post('/updateDepartmentForDesignationAction')
  async updateDepartmentForDesignationAction(@Body() employeeId: number, departmentId: string): Promise<CommonResponse> {
    try {
      return await this.employeeDetailsService.updateDepartmentForDesignationAction(employeeId, departmentId);
    } catch (error) {
      // return errorHandler(EmployeeResponseModel, error);
      return this.applicationExceptionHandler.returnException(EmployeeResponseModel, error);
    }
  }


}
